import { render } from "./Sicurezza.vue?vue&type=template&id=c2c57bc6&scoped=true"
import script from "./Sicurezza.vue?vue&type=script&lang=js"
export * from "./Sicurezza.vue?vue&type=script&lang=js"

import "./Sicurezza.vue?vue&type=style&index=0&id=c2c57bc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2c57bc6"]])

export default __exports__